export const facialRecognition = {
  'All right!': 'Tudo certo!',
  'We’ve confirmed your identity! You can keep enjoying a hair-free life with us!':
    'Confirmamos sua identidade! Você pode continuar a aproveitar uma vida livre de pelos conosco!',
};
